<template>
  <form class="form-base">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          :disabled="disabled"
          label="Наименование"
          outlined
					@blur="v.name.$touch"
        />
      </v-col>
      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="v.address.$model = $event"
          :v="v.address"
          label="Адрес (место нахождения) организации"
          :notice-recovery="true"
          :global-disabled="disabled"
					@blur="v.address.$touch"
          :translationKey="translationKey ? `${translationKey}.addr` : undefined"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :disabled="disabled"
          label="ИНН организации"
          outlined
					@blur="v.inn.$touch"
        />
      </v-col>
    </v-row>
    <v-divider class="divider" />
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.changeReason.$model"
          :errorMessages="getValidationErrorText(v.changeReason)"
          :disabled="disabled"
          label="Причина изменения кредитора"
          outlined
          @input="$emit('change-reason', $event)"
					@blur="v.changeReason.$touch"
        />
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { maxLength, required } from 'vuelidate/lib/validators';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
  name: '',
  address: {},
  inn: '',
  changeReason: '',
};

export const foreignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    maxLength: maxLength(10),
    EMOJI,
  },
  changeReason: {
    maxLength: maxLength(4000),
    EMOJI,
  },
};

export default {
  name: 'ForeignOrganization',
  components: { AddressStructuredField },
  props: {
    v: Object,
    disabled: Boolean,
    translationKey: String,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>

<style scoped></style>
